/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function setCookie(name, value) {
  var days = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  var ONE_DAY_MS = 24 * 60 * 60 * 1000;

  var expires = new Date(Date.now() + days * ONE_DAY_MS).toUTCString();
  document.cookie = name + '=' + value + '; expires=' + expires + '; path=/';
}

function getCookie(name) {
  var match = document.cookie.split('; ').find(function (row) {
    return row.startsWith(name + '=');
  });

  return match ? match.split('=')[1] : null;
}

var isLen4prep = window.location.pathname.includes('len4prep');
var isHcp = !isLen4prep && getCookie('entry-popup-hcp') === 'hcp' || isLen4prep && getCookie('entry-popup-hcp-len4prep') === 'hcp';

function loadDocIframe() {
  var iframe = document.querySelector('#doc-viewer');
  if (iframe && iframe.contentWindow) iframe.contentWindow.postMessage('load_doc');
}

function entryPop() {
  var js_entry_pop = document.querySelector('.js-entry-pop');

  if (!js_entry_pop) return;

  js_entry_pop.classList.remove('is-hidden');
  document.body.classList.add('overflow-x-hidden');

  document.querySelectorAll('.js-entry-pop-btn').forEach(function (btn) {
    btn.addEventListener('click', function (event) {
      event.preventDefault();

      var type = btn.dataset.type;
      var link = btn.dataset.link;

      if (type === 'hcp') {
        var cookieName = isLen4prep ? 'entry-popup-hcp-len4prep' : 'entry-popup-hcp';
        setCookie(cookieName, 'hcp'); // 1 day
        js_entry_pop.classList.add('is-hidden');
        loadDocIframe();
      } else {
        window.location = link;
      }

      document.body.classList.remove('overflow-x-hidden');
    });
  });
}

if (!isHcp) {
  entryPop();
} else {
  loadDocIframe();
}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// entry-modal.bundle.js